<template>
  <div class="container">
    <div class="row justify-content-end">
      <div class="col-md-8 col-sm-12">
        <div class="card p-md-5 p-2">
          <div class="card-body">
            <div v-html="content.txt.replace('{{firstName}}', firstName)"></div>
            <div class="text-end">
              <button class="btn btn-primary" @click="start">{{content.submit}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Response} from "@/classes/response";

export default {
  name: 'Welcome',
  props: ['initData','contents'],
  data(){
    this.initData.bigImage = 10
    return{
      firstName : this.initData.user.firstName
    }
  },
  computed:{
    content(){
      return this.contents.welcome
    },
    firstName() {
      return this.initData.user.firstName
    }
  },
  methods:{
    start(){
      this.initData.loader = true

      this.$axios.post('/api/v1/user/start')
          .then((response) => {
            let responseData =  new Response().handle(response)
            this.initData.alerts.push({msg: responseData.msg, type: responseData.msgType})

            if(responseData.status===true) {
              console.log(responseData)
              this.initData.user.status = responseData.data.status
              this.initData.user.questionData = responseData.data.questionData
            }
          })
          .catch(error => {
            console.log(error)
            let responseData =  new Response()
            responseData.errorHandle(error.response)
            this.initData.alerts.push({msg: responseData.msg, type: responseData.msgType})
          })
          .then(() => {
            this.initData.loader = false
          });
    }
  }

}
</script>
<style scoped>
.container{
  max-width: 1280px;
  padding-top: 2rem;
  padding-bottom: 6rem;
}
.card{
  background-color: rgba(255,255,255,0.9);
}
.card-body a{
  color: #B40041;
  text-decoration: none;
}
</style>
